import Model from "../Model";

class BubblesDivisonDetail extends Model{

    buildUrl ({ param }) {
        return ['divisionview/details', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new BubblesDivisonDetail;